import http from "helpers/http.js";

const API_URL = process.env.REACT_APP_API_URL || 'https://localhost:44303/';

const getArticles = async (params = {}) => {
    try {
        const query = new URLSearchParams();
        if (params.categorySlug) query.append('categorySlug', params.categorySlug);
        if (params.tag) query.append('tag', params.tag);
        if (params.page) query.append('page', params.page);
        if (params.pageSize) query.append('pageSize', params.pageSize);
        const qs = query.toString();
        const response = await http.get(`${API_URL}api/public/articles${qs ? '?' + qs : ''}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching articles:', error);
        throw error;
    }
};

const getArticleBySlug = async (slug) => {
    try {
        const response = await http.get(`${API_URL}api/public/articles/${encodeURIComponent(slug)}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching article ${slug}:`, error);
        throw error;
    }
};

const getCategories = async () => {
    try {
        const response = await http.get(`${API_URL}api/public/articles/categories`);
        return response.data;
    } catch (error) {
        console.error('Error fetching article categories:', error);
        throw error;
    }
};

const getFeaturedArticles = async () => {
    try {
        const response = await http.get(`${API_URL}api/public/articles/featured`);
        return response.data;
    } catch (error) {
        console.error('Error fetching featured articles:', error);
        throw error;
    }
};

const getArticlePreview = async (slug, token, t) => {
    try {
        const response = await http.get(
            `${API_URL}api/public/articles/preview/${encodeURIComponent(slug)}?token=${encodeURIComponent(token)}&t=${encodeURIComponent(t)}`
        );
        return response.data;
    } catch (error) {
        console.error(`Error fetching article preview ${slug}:`, error);
        throw error;
    }
};

const articlesService = {
    getArticles,
    getArticleBySlug,
    getCategories,
    getFeaturedArticles,
    getArticlePreview
};

export default articlesService;
